import { Controller } from "@hotwired/stimulus"

// FO name picker on booking forms. The <select> is the primary submitted field
// (so the booking[fo_name] string stays compatible with the FO incentive report,
// and the surrounding dashboard/hotel-booking controller can still toggle its
// `required` attribute). Choosing "Other" disables the select and enables a
// free-text input instead — only one is ever enabled, so only one submits.
export default class extends Controller {
  static targets = ["select", "input"]

  connect() {
    const value = this.inputTarget.value
    if (value && !this.#optionExists(value)) {
      this.selectTarget.value = "__other__"
      this.#activateOther()
    } else {
      if (value) this.selectTarget.value = value
      this.#activateSelect()
    }
  }

  choose() {
    if (this.selectTarget.value === "__other__") {
      this.inputTarget.value = ""
      this.#activateOther()
      this.inputTarget.focus()
    } else {
      this.#activateSelect()
    }
  }

  #activateSelect() {
    this.selectTarget.disabled = false
    this.inputTarget.disabled = true
    this.inputTarget.classList.add("hidden")
  }

  #activateOther() {
    this.selectTarget.disabled = true
    this.inputTarget.disabled = false
    this.inputTarget.classList.remove("hidden")
  }

  #optionExists(value) {
    return Array.from(this.selectTarget.options)
      .some((option) => option.value === value && option.value !== "__other__")
  }
}
